module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<h4>'+
((__t=( i18n.tc("UnitFirmware", "Firmware") ))==null?'':__t)+
'</h4> ';
 if ( ! error )  { 
__p+=' ';
 if ( ! firmware ) { 
__p+=' <p>'+
((__t=( i18n.tc("UnitFirmware", "Making sure your device has the latest firmware version, please wait...") ))==null?'':__t)+
'</p> ';
 } 
__p+=' <div class="progress indeterminate';
 if ( firmware ) { 
__p+=' fade-out';
 } 
__p+='"><div class="bar progress-bar"></div><div class="bar buffer-bar"></div><div class="bar aux-bar"></div></div> ';
 } 
__p+=' ';
 if ( firmware ) { 
__p+=' <p><span class="success">'+
((__t=( i18n.tc("UnitFirmware", "Firmware upgraded!") ))==null?'':__t)+
'</span></p> ';
 } 
__p+=' ';
 if ( error ) { 
__p+=' <p><span class="error">'+
((__t=( i18n.tc("UnitFirmware", "Firmware failed to connect!") ))==null?'':__t)+
'</span></p> ';
 } 
__p+='';
}
return __p;
};
